import VipRecall from '~/pages/vip/pages/recall/reducers'
import Vip from '../pages/vip/pages/index/reducers'
import VipRecord from '../pages/vip/pages/record/reducers'
import VipMission from '../pages/vip/pages/mission/reducers'
import VipBenefit from '../pages/vip/pages/benefit/reducers'
import VipActivity from '../pages/vip/pages/activity/reducers'
import VipHonor from '../pages/vip/pages/honor/reducers'
import VipID from '../pages/vip/pages/id/reducers'
import VipMIB from '../pages/vip/pages/mib/reducers'
import VipBouns from '../pages/vip/pages/bounsPlay/reducers'

export default {
  Animal_Whale: Vip,
  Animal_Elephant: VipRecord,
  Animal_Ant: VipMission,
  Animal_Dolphin: VipBenefit,
  Animal_Armadillo: VipActivity,
  Animal_Ferret: VipHonor,
  Animal_Gecko: VipID,
  Animal_Bat: VipRecall,
  Animal_Bear: VipMIB,
  Animal_Elk: VipBouns,
}
